export const getMeterChartOptions = ({max, range, value, width = 450, height = 297}) => {
    return {
        chart: {
            type: "gauge",
            plotBackgroundColor: "#fff",
            plotBackgroundImage: undefined,
            plotBorderWidth: 0,
            plotShadow: false,
            width: width,
            height: height,
        },
        title: {
            text: "",
        },
        plotOptions: {
            gauge: {
                dial: {
                    radius: "95%",
                    backgroundColor: "#23366F",
                    borderColor: "#23366F",
                    borderWidth: 1,
                    baseWidth: 12,
                    topWidth: 3,
                    baseLength: "0%", // of radius
                    rearLength: "0%",
                    borderRadius: 0, // v13 default is '9%'
                    //   color: '#ff0000'
                },
                // v13 changed pivot defaults (radius '4%', borderWidth 2, white fill)
                pivot: {
                    radius: 5,
                    borderWidth: 0,
                    backgroundColor: "#23366F",
                },
            },
        },

        pane: {
            startAngle: -90,
            endAngle: 89.9,
            background: undefined,
            center: ["50%", "75%"],
            size: "120%",
            // v13 defaults gauges to innerSize '85%' and borderRadius 3
            innerSize: 0,
            borderRadius: 0,
        },

        // the value axis
        yAxis: {
            min: 0,
            max: max || 20,
            // v13 dropped these gauge-axis defaults and added an offset of '-20%'
            startOnTick: false,
            endOnTick: false,
            lineWidth: 1,
            offset: 0,

            minorTickInterval: "auto",
            minorTickWidth: 0,
            minorTickLength: 2,
            minorTickPosition: "inside",
            minorTickColor: "#666",

            tickPixelInterval: 40,
            tickWidth: 0,
            tickPosition: "inside",
            tickLength: 1,
            tickColor: "#666",
            labels: {
                step: 1,
                rotation: 0,
                distance: -25, // v13 default is 15
                y: 0,
                style: {
                    color: "#2C438B",
                    fontSize: "21px",
                },
            },
            title: {
                text: "",
            },
            plotBands: [
                {
                    from: 0,
                    to: max,
                    color: {
                        linearGradient:  { x1: 1, x2: 0, y1: 0, y2: 0 },
                        stops: [
                            [0, '#91C8F2'],
                            [1, '#23366F']
                        ],
                    },
                    outerRadius: "125%",
                    thickness: "25%",
                },
                {
                    from: range?.from || 0.0001,
                    to: range?.to || 15,
                    color: "#DDE4E3",
                    outerRadius: "125%",
                    thickness: "25%",
                },
            ],
        },

        series: [
            {
                type: "gauge",
                name: "Risk",
                data: [value || 0],
                tooltip: {
                    valueSuffix: " %",
                },
                dataLabels: {
                    format: "{y} %",
                    borderWidth: 0,
                    y: 15, // v13 default is 25
                    color: "#0F67BF",
                    style: {
                        fontSize: "27px",
                    },
                },
            },
        ],
    }
}